import { Field } from 'components/Form/Field/Field';
import { Textarea } from 'components/Textarea/Textarea';

type Props = {
  name: string;
  label?: string;
  description?: string;
  'data-qa-id'?: string;
  disabled?: boolean;
  onChange: (newValue: string) => void;
  type: 'TEXT';
};

export function RequestedTextUserField({
  name,
  label,
  description,
  'data-qa-id': qaId,
  type,
  disabled,
  onChange,
}: Props) {
  if (type !== 'TEXT') return null;
  const subName = `${name}.${type.toLowerCase()}`;
  return (
    <Field
      customErrorMatch={(errors) => errors[name] || errors[subName]}
      name={name}
      label={label}
      description={description}
      renderInput={({ value, qaId: autoQaId, updateValue }) => (
        <Textarea
          disabled={disabled}
          name={name}
          data-qa-id={`${qaId || autoQaId}-hidden-input`}
          onChange={(e) => {
            const v = e.target.value;

            onChange(v);

            updateValue(
              v
                ? {
                    type: 'TEXT',
                    text: v,
                  }
                : null,
            );
          }}
          value={value ? value.text : ''}
        />
      )}
    />
  );
}
